import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createLogger, Sentry } from "./infrastructure/services/logger";
import App from "./App";
import "@ir/ui/dist/style.css";
import { LoggerProvider } from "./providers/logger";


createRoot(document.getElementById("root")!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    const logger = createLogger("main");
    logger.warn('Uncaught error:', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <LoggerProvider>
      <App />
    </LoggerProvider>
  </StrictMode>
);
